// Mirrors the server's src/utils/passwordPolicy.js — the server is the actual enforcement;
// this lets forms show exactly what's missing before submitting.
export const PASSWORD_REQUIREMENTS = [
  { label: 'At least 10 characters', test: (pw) => pw.length >= 10 },
  { label: 'An uppercase letter', test: (pw) => /[A-Z]/.test(pw) },
  { label: 'A lowercase letter', test: (pw) => /[a-z]/.test(pw) },
  { label: 'A number', test: (pw) => /\d/.test(pw) },
  { label: 'A special character', test: (pw) => /[^A-Za-z0-9]/.test(pw) },
];

// Returns a user-facing reason the password is rejected, or null if it's acceptable.
export function passwordProblem(pw) {
  const missing = PASSWORD_REQUIREMENTS.filter((r) => !r.test(pw || '')).map((r) => r.label.toLowerCase());
  return missing.length ? `Password needs: ${missing.join(', ')}.` : null;
}
